import { useState, useContext } from 'react';

import CardPile from '@/components/game/ui/modal/cards/CardPile';
import CardPileEquipment from '@/components/game/ui/modal/cards/CardPileEquipment';
import { GameContext } from '@/state/contexts';
import { getPlayerStateWithId } from '@/util/player';

/**
 * Active contracts & awards
 * Completed Contracts & awards
 * Failed Contracts & awards
 * Equipment
 * Toggle between players
 */

const CardsOnTableModal = ({
	onClose,
	currentPlayerId,
	equipmentAction,
	cardsOnTablePlayerId,
}) => {
	const [playerId, setPlayerId] = useState(
		cardsOnTablePlayerId < 0 ? currentPlayerId : cardsOnTablePlayerId
	);

	const { currPlayer, players, playerStateArray } = useContext(GameContext);

	const updateCardsOnTable = (id) => {
		setPlayerId(id);
	};

	const handlePlayerChange = (event) => {
		const pId = parseInt(event.target.value);
		updateCardsOnTable(pId);
	};

	// function equipmentAction(e, cardId){
	//   e.preventDefault();
	//   socket.emit('playEquipmentCardById', { ...currPlayer, cardId }); // targetId,
	//   onClose();
	// }

	// show ALL CARDS on table for selected player
	if (playerId === -1) return <></>;

	const viewPlayer = getPlayerStateWithId(playerStateArray, playerId);

	return (
		<div className="modal" onClick={onClose}>
			<div className="modal-content" onClick={(e) => e.stopPropagation()}>
				<span className="close" onClick={onClose}>
					&times;
				</span>
				<div>
					Player:
					<select
						id="playerSelect"
						value={playerId}
						onChange={handlePlayerChange}
					>
						{playerStateArray.map((p) => (
							<option key={p.playerId} value={p.playerId}>
								{p.color}
							</option>
						))}
					</select>
				</div>
				<CardPile
					title={'Active Contracts and Awards'}
					cards={viewPlayer.activeContractsAndAwards}
				/>
				<CardPileEquipment
					title={'Equipment'}
					cards={viewPlayer.equipment}
					equipmentAction={equipmentAction}
					playerId={playerId}
				/>
				<CardPile
					title={'Completed Contracts'}
					cards={viewPlayer.completedContracts}
				/>
				<CardPile
					title={'Completed Awards'}
					cards={viewPlayer.completedAwards}
				/>
				<CardPile
					title={'Failed Contracts'}
					cards={viewPlayer.failedContracts}
				/>
			</div>
		</div>
	);
};

export default CardsOnTableModal;
